@let isDemoUser = profile.isDemoUser$ | async;

<p-dialog
  (visibleChange)="close()"
  [modal]="true"
  [visible]="isOpened()"
  class="dialog-primary w430"
>
  <ng-template pTemplate="header">
    <header>
      <div class="title text-18 fw-600">
        {{ 'users.profile.edit-profile' | translate }}
      </div>
    </header>
  </ng-template>

  <form class="form">
    <div class="profile-section mb-16">
      <header class="label text-16 fw-600">
        {{ 'users.profile.title' | translate }}
        <div class="counter text-12 fw-600">
          {{ (profile.roleLabelKey$ | async) || '' | translate }}
        </div>
      </header>
      <div class="horizontal-spacer--16"></div>
      <div class="profile-body">
        <div class="personal-info mb-12">
          <app-avatar [photo]="state.avatarUrl$ | async" class="clickable" size="56"></app-avatar>

          <div class="info-wrapper">
            <div class="name text-14 fw-500">
              {{ 'users.profile.profile-photo' | translate }}
            </div>
            <div class="email text-13 fw-500">
              {{ 'users.profile.recommended-resolution' | translate }} 300 x 300
            </div>
          </div>
        </div>

        <div class="controls flex mb-16 gap-8">
          @if (state.avatarUrl$ | async) {
            <p-button
              class="text-14 fw-600 h--40 w50"
              [disabled]="isDemoUser"
              [severity]="'secondary'"
              (click)="fileInput.click()"
            >
              {{ 'button.change' | translate }}
            </p-button>
            <p-button
              class="text-14 fw-600 h--40 w50"
              [disabled]="isDemoUser"
              [severity]="'secondary'"
              (click)="model.removeAvatar()"
            >
              {{ 'button.remove' | translate }}
            </p-button>
          } @else {
            <p-button
              class="text-14 fw-600 h--40 w100"
              [disabled]="isDemoUser"
              [severity]="'secondary'"
              (click)="fileInput.click()"
            >
              {{ 'button.upload' | translate }}
            </p-button>
          }
        </div>

        <p-fluid>
          <div class="label mb-12 text-14 fw-500">{{ 'feedback.name-label' | translate }}</div>
          <input
            #nameInput
            (blur)="model.setName(nameInput.value)"
            [value]="state.userName$ | async"
            class="h--40 text-14 fw-500"
            pInputText
          />
        </p-fluid>
      </div>
    </div>

    <div class="security-section">
      <header class="label text-16 fw-600">
        {{ 'users.profile.security' | translate }}
      </header>
      <div class="horizontal-spacer--16"></div>
      <div class="flex--col gap-12">
        <section class="flex w100 justify-space-between">
          <div>
            <div class="label text-16 fw-600">{{ 'sign-in.password' | translate }}</div>
            <div class="password-hidden text-13 fw-500">{{ PASSWORD_PLACEHOLDER }}</div>
          </div>
          <p-button
            [routerLink]="['/', 'change-password']"
            [severity]="'secondary'"
            [disabled]="isDemoUser"
            class="w55 p--18 h--40 text-14 fw-600"
          >
            {{ 'users.profile.change-password' | translate }}
          </p-button>
        </section>
        <section class="flex w100 justify-space-between">
          @let isMfaEnabled = isTotpMfaEnabled();
          <div>
            <div class="label text-16 fw-600" [appTooltip]="'users.form.2fa' | translate">
              {{ 'users.profile.2fa' | translate }}
            </div>
            <div class="password-hidden text-13 fw-500">
              @if (isMfaEnabled) {
                {{ 'common.enabled' | translate }}
              } @else {
                {{ 'common.disabled' | translate }}
              }
            </div>
          </div>

          @if (isMfaEnabled) {
            <p-button
              (click)="disableMfa()"
              [severity]="'secondary'"
              [disabled]="isDemoUser || isDisableMfaProcessing() || strictMfaEnforcementMode()"
              [loading]="isDisableMfaProcessing()"
              class="w55 p--18 h--40 text-14 fw-600"
            >
              {{ 'common.disable' | translate }}
            </p-button>
          } @else {
            <p-button
              (click)="authSetupDialogRef.open()"
              [severity]="'secondary'"
              [disabled]="isDemoUser"
              class="w55 p--18 h--40 text-14 fw-600"
            >
              {{ 'common.enable' | translate }}
            </p-button>
          }
        </section>
      </div>
    </div>

    @if (isPushNotificationsAvailable()) {
      <div class="pushes-section mt-16">
        <div>
          <div class="label text-16 fw-600">
            {{ 'users.profile.push-notifications' | translate }}
          </div>
        </div>
        @if (pushes.isRegistered$ | async) {
          <div class="text-14 fw-500 color-gray-500">
            {{ 'common.enabled' | translate }}
          </div>
        } @else {
          <p-button
            (click)="enablePushes()"
            [severity]="'secondary'"
            class="p--18 h--40 text-14 fw-600"
          >
            {{ 'common.enable' | translate }}
          </p-button>
        }
      </div>
    }

    <div class="errors-box">
      @if (state.errorMessage$ | async; as error) {
        <p class="error-message">{{ error }}</p>
      }
    </div>
  </form>

  <div class="footer">
    <p-button
      class="text-14 fw-600 h--40 w100"
      [disabled]="(state.isLoading$ | async) || isDemoUser"
      (click)="model.saveUpdates(); close()"
    >
      {{ 'button.save' | translate }}
    </p-button>
  </div>

  <input
    #fileInput
    (change)="model.onUserAvatarSelected($event)"
    accept=".jpg, .jpeg, .png"
    type="file"
  />
</p-dialog>

<app-authenticator-setup-dialog
  #authSetupDialogRef
  [cancelDisabled]="strictMfaEnforcementMode() && !isTotpMfaEnabled()"
></app-authenticator-setup-dialog>
